module.exports = __webpack_public_path__ + "static/media/logo.81b89269.svg";